import { type MutationTree } from 'vuex';

import { type IBriefState } from '../brief-module/types';

export const ADD_TAG_FOR_BRIEF = 'addTagForBrief';
export const REMOVE_TAG_FROM_BRIEF = 'removeTagFromBrief';

export const mutations: MutationTree<IBriefState> = {
    [ADD_TAG_FOR_BRIEF](_state: IBriefState, { briefIds, tagId }: { briefIds: number[]; tagId: number }) {
        briefIds.forEach((briefId) => {
            const briefTagList = _state.dataObjectList.get(briefId)['@tags'] ?? [];
            briefTagList.push(tagId);

            _state.dataObjectList.get(briefId)['@tags'] = briefTagList;
        });
    },

    [REMOVE_TAG_FROM_BRIEF](_state: IBriefState, { briefIds, tagId }: { briefIds: number[]; tagId: number }) {
        briefIds.forEach((briefId) => {
            if (_state.dataObjectList.has(briefId)) {
                const briefTagList = (_state.dataObjectList.get(briefId)['@tags'] ?? []).filter((tag: number) => {
                    return tag !== tagId;
                });

                _state.dataObjectList.get(briefId)['@tags'] = briefTagList;
            }
        });
    }
};
